export const CONFIRM_ICONS = {
  SAVE: 'save',
  IMPORTANT: 'notification_important',
  WARNING: 'warning',
  ACTIVE: 'notifications_active',
  CANCEL: 'cancel',
  SUCCESS: 'check-circle-regular',
  NOTIFICATION: 'notification',
  COPY: 'copy',
  QUESTION: 'question',
  INFO: 'information'
};

export const CONFIRM_COLOR = {
  PRIMARY: 'primary',
  WARN: 'warn',
  SUCCESS: 'button-success'
};

export const TYPE_MODAL = {
  NOTIFICATION: 'notification',
  INVALID: 'invalid',
  ACCEPT: 'accept'
};

/**
 * Notificaciones reutilizadas en más de un módulo
 */

export const DELETE_ITEM = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Está seguro de eliminar lo seleccionado?',
  valueButton: 'Eliminar',
  color: CONFIRM_COLOR.WARN,
  icon: CONFIRM_ICONS.IMPORTANT
};

export const SAVE = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Desea guardar la información?',
  valueButton: 'Continuar',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.SAVE
};

export const CLEAN = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: 'Se perderá tu información ¿Estás seguro de que desea limpiar?',
  valueButton: 'Limpiar',
  color: CONFIRM_COLOR.WARN,
  icon: CONFIRM_ICONS.WARNING
};

export const EXIT = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Desea salir de la operación?',
  valueButton: 'Salir',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.NOTIFICATION
};



